import {SxType} from '@baseTypes/sx/sxTypes'

export default {
	container: {
		height: '100%',
		p: 3,
		'.lightTheme &': {
			bgcolor: '#fcfcfc',
		},
		paddingBottom: '20px'
	},
	header: {
		display: 'flex',
		justifyContent: {
			xs: 'space-between',
		},
		alignItems: 'center',
		mb: 3,
		width: '100%',
		gap: '20px',
		flexWrap: 'wrap'
	},
	searchField: {
		width: {
			xs: '100%',
			lg: 'calc(100% - 320px)'
		},
		'.lightTheme &': {
			bgcolor: 'white',
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: '8px',
		}
	},
	card: {
		borderRadius: 3,
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		transition: 'transform 0.2s',
		'&:hover': {
			boxShadow: 3,
			borderColor: 'var(--account-accent-tint, rgba(12, 109, 223, 0.35))',
		},
	},
	cardHeader: {
		position: 'relative',
		p: 2,
		borderBottom: '1px solid',
		borderColor: 'divider',
		backgroundColor: 'var(--account-accent-soft, transparent)',
		'.lightTheme &': {
			backgroundColor: 'var(--account-accent-soft, #f2f2ee)',
		},
	},
	statusDot: (isActive: boolean) => ({
		width: 8,
		height: 8,
		bgcolor: isActive ? 'success.main' : 'text.disabled',
		borderRadius: '50%',
		flexShrink: 0,
	}),
	brandChip: (type: string) => ({
		fontWeight: 'bold',
		borderRadius: 1,
		color: 'var(--account-accent-text, #1976d2)',
		bgcolor: type === 'MDVR' ? 'var(--account-accent-soft, #e3f2fd)' : 'transparent',
		border: '1px solid',
		borderColor: 'var(--account-accent-tint, #90caf9)',
		height: 24,
	}),
} as const satisfies SxType
